export enum CompanyPageRouterOutlet {
    ContentAside = 'contentAside',
    ContentAsideSticky = 'contentAsideSticky',
    Footer = 'footer',
}
